<template>
    <div>
        <b-form-row>
            <date-time-picker class="col-xs-12 col-lg-8 col-xl-6 mt-2"
                              ref="executionDate"
                              title="Выполнено"
                              name="executionDate"
                              :editable="isEditable('executionDate')"
                              :key="getExecutionDateStr()"
                              :show-timepicker="true"
                              :date-required="true"
                              :state="validateState('executionDate')"
                              :initial-date-string="getExecutionDateStr()"
                              @date-changed="onModelDateChanged" />
        </b-form-row>

        <b-form-row>
            <form-field class="col-xs-12  col-lg-8 col-xl-6 mt-2 mt-3"
                        :class="{ 'required' : isEditable('executorName') }"
                         :label="getFieldLabel('executorName')"
                         :editable="isEditable('executorName') "
                         :value="object.executorName"
                         :feedback="liveFeedback('executorName')">
                <template #field>
                    <b-form-input
                        id="executorName"
                        class="w-100"
                        type="text"
                        v-model="$v.form.executorName.$model"
                        :state="validateState('executorName')">
                    </b-form-input>
                </template>
            </form-field>
        </b-form-row>

        <b-form-row>
            <form-field  v-if="needsContractType" class="required col-xs-12 col-sm-8 col-lg-4 mt-3"
                         label="Тип контракта"
                         :editable="canEditContractType"
                         :value="getContractTypeText">
                <template #field>
                    <radio-list id="contractType" name="contractType"
                                v-model="contractType" :url="getContractTypesUrl"
                                @radio-changed="onContractTypeChanged"/>
                </template>
            </form-field>

            <form-field class="col-xs-12 col-lg-8 col-xl-6 mt-3 required"
                :editable="canEditContract"
                :label="getFieldLabel('executorContract')"
                :value="getContractValueName"
                :feedback="liveFeedback('executorContract')">
                <template #field>
                    <single-select name="executorContract"
                                   class="flex-grow-1 mr-2"
                                   v-model="form['executorContractObject']"
                                   :url="getContractsUrl"
                                   label-key="full_description"
                                   :initial-filters="getContractInitialFilters"
                                   :label="getFieldLabel('executorContract')"
                                   :state="getValidationClass('executorContract')"
                                   v-on:select-changed="onModelObjectSingleSelectChanged"
                                   v-on:select-cleared="onModelObjectSingleSelectCleared" />
                </template>
            </form-field>
        </b-form-row>

    </div>
</template>

<script>
import {BaseEvent, eventFactory, EventKind, eventNeedsInitialKeeping, eventNeedsInitialMunicipality} from "./event";
    import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
    import FormField from "../../../components/Forms/FormField";
    import DateTimePicker from "../../../components/Forms/DateTimePicker";
    import api from "../../../api";
    import { mapGetters } from 'vuex';
    import SingleSelect from "@/components/Select/SingleSelect";
    import Gallery from "@/components/Files/Gallery.vue";
    import RadioList from "@/components/Select/RadioList.vue";
    import {CONTRACT_TYPE} from "@/pages/AppPages/Catalogs/Contracts/contract";

    export default {
        name: "CommonEvent",
        components: {RadioList, Gallery, SingleSelect, FormField, DateTimePicker },
        props: {
            eventData: { type: Object, default: () => { return {} } },  // should reset on change
            kind: null,
            editable: { type: Boolean, default: true },
            selectedMunicipality: { type: Object, default: () => { return {} } },
            catchingContract: { type: Object, default: () => { return {} } },
            keepingContract: { type: Object, default: () => { return {} } },
        },
        data() {
            return {
                contractType: 1,
            }
        },
        mixins: [ObjectComponentMixin],
        computed: {
            ...mapGetters(['userOrganizationId', 'hasMunicipalityRestrictions',
                'isSuperuser', 'isInController', 'isInContractor', 'isVetControl']),
            getContractsUrl() {
                return api.contracts.default.list();
            },
            getContractTypesUrl() {
                return api.contracts.types.list();
            },
            getContractTypeText() {
                return CONTRACT_TYPE[this.contractType]
            },
            needsKeepingEvent() {
                return eventNeedsInitialKeeping(this.kind)
            },
            needsContractType() {
                return !this.isVetControl;
            },
            canEditContract() {
                const needsMunicipality = eventNeedsInitialMunicipality(this.kind);
                const needsContractType = this.needsContractType;
                return this.isSuperuser || (
                    this.editable
                    && this.getAbility('executorContract')
                    && !Boolean(this.keepingContract)
                    && (!needsContractType || needsContractType &&  Boolean(this.contractType))
                    && (!needsMunicipality || needsMunicipality && Boolean(this.selectedMunicipality))
                )
            },
            canEditContractType() {
                const needsMunicipality = eventNeedsInitialMunicipality(this.kind);
                return this.isSuperuser || (
                    this.editable
                    && this.getAbility('contractType')
                    && this.getAbility('executorContract')
                    && !Boolean(this.keepingContract)
                    && (!needsMunicipality || needsMunicipality && Boolean(this.selectedMunicipality))
                )
            },
            getContractInitialFilters() {
                let filters = [];
                if (!this.isSuperuser) {
                    filters.push({key: 'is_valid', value: true})
                }
                if (this.needsContractType) {
                    filters.push({key: 'contract_type', value: this.contractType})
                }
                if (this.isInContractor && !this.isSuperuser) {
                    filters.push({key: 'contractor', value: this.userOrganizationId})
                }
                if (this.selectedMunicipality) { filters.push({key: 'municipality', value: this.selectedMunicipality['id']}) }
                if (this.keepingContract) { filters.push({key: 'contract_id', value: this.keepingContract['id']}) }
                return filters
            },
            getContractValueName() {
                return this.object.executorContractObject ? this.object.executorContractObject['full_description'] : null
            }
        },
        methods: {
            resetContract() {
                this.form['executorContract'] = null;
                this.form['executorContractObject'] = {};
                this.$v.form.executorContract.$touch();
            },
            getExecutionDateStr() {
                return this.object.executionDate
            },
            onContractTypeChanged(name, item, data) {
                this.contractType = item;
                this.resetContract();
            },
            onMunicipalityChanged(item) {
                this.resetContract();
            },
            isEditable(fieldName) {
                return this.getAbility(fieldName) && this.editable
            }
        },
        beforeMount() {
            this.objectClass = eventFactory(this.kind);
            this.objectData = this.eventData;
            if (!this.eventData['id']) {
                if (this.keepingContract && this.keepingContract['id']) {
                    this.initObjectParams['executorContract'] = this.keepingContract['id'];
                    this.initObjectParams['executorContractObject'] = this.keepingContract;
                }
                if (this.catchingContract && this.catchingContract['id']) {
                    this.initObjectParams['executorContract'] = this.catchingContract['id'];
                    this.initObjectParams['executorContractObject'] = this.catchingContract;
                }
            }
        },
        mounted() {
            const vm = this;
            vm.onMount();
            vm.resetForm().then(() => {
                vm.contractType = this.object.executorContractObject['id'] ? this.object.executorContractObject['contract_type'] : 1
            });
        }
    }
</script>

<style scoped>

</style>